import { LOANREQUEST_STATUS_REASONS, LOANREQUEST_STATUSES, REASON_CATEGORIES } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaCanceled = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.CANCELED),
        statusReason: z.array(z.nativeEnum(LOANREQUEST_STATUS_REASONS)),
        subStatus: z.nativeEnum(REASON_CATEGORIES).optional(),
    })
    .merge(commonSchema);

export type SCHEMA_CANCELED = z.infer<typeof schemaCanceled>;
